/* src/app/notify-templates/notify-template-form/notify-template-form.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
@media screen and (min-width: 48rem) {
  .notify-template-form {
    width: 40em;
    max-width: 100%;
  }
}
.notify-template-form .template-images {
  padding: 1em 0;
  margin: 1em 0;
}
.notify-template-form .template-images p {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.87);
  margin-top: 0;
}
.notify-template-form .section-title {
  font-weight: 700;
  position: relative;
}
.notify-template-form .section-title::after {
  content: "*";
  color: #DF2901;
  font-size: 0.8em;
  position: absolute;
  top: 0;
  margin-left: 0.25em;
}
.notify-template-form .cover-image-wrapper,
.notify-template-form .banner-image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin-bottom: 2em;
  padding-top: 1em;
  position: relative;
}
@media screen and (min-width: 48rem) {
  .notify-template-form .cover-image-wrapper,
  .notify-template-form .banner-image-wrapper {
    flex-direction: row;
    align-items: center;
  }
}
.notify-template-form .showcase-images-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
.notify-template-form label.mat-mdc-raised-button {
  margin-right: 2em;
}
.notify-template-form .image-selector {
  position: relative;
}
.notify-template-form .image-selector.showcase {
  margin-top: 1em;
}
.notify-template-form .image-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.notify-template-form .image-item > .file-name {
  width: 70%;
  max-width: 15em;
  color: #009cbd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notify-template-form .form-actions .mat-mdc-raised-button {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .notify-template-form .form-actions .mat-mdc-raised-button {
    width: auto;
  }
}
.divider {
  display: block;
  border-top: solid thin #e8e8e6;
  margin: 1em -5em 1em -3em;
}
/*# sourceMappingURL=notify-template-form.component.css.map */
